const TopNavBarSpan = ({ topTab, selectTab, tabName, tabText }) => {
  const isActive = topTab === tabName;

  return (
    <div
      className={`student-nav__tab${isActive ? " student-nav__tab--active" : ""}`}
      onClick={() => selectTab(tabName)}
    >
      {tabText}
      {isActive && <span className="student-nav__tab-underline" />}
    </div>
  );
};

export default TopNavBarSpan;
